import logger from '@gumtree/logger';

export default logger('@gumtree/message-centre');
